class StratoProduct {
  constructor(root) {
    this.root = root
    this.variants = JSON.parse(root.querySelector('[data-variants-json]')?.textContent || '[]')
    this.variantInput = root.querySelector('[data-variant-id]')
    this.form = root.querySelector('[data-product-form]')
    this.button = root.querySelector('[data-add-to-cart]')
    this.label = root.querySelector('[data-add-label]')
    this.price = root.querySelector('[data-add-price]')
    this.error = root.querySelector('[data-product-error]')
    this.bind()
  }

  bind() {
    this.root.querySelectorAll('[data-option-value]').forEach(input => {
      input.addEventListener('change', () => this.updateVariant())
    })
    this.root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(-1))
    this.root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(1))
    this.form?.addEventListener('submit', event => this.addToCart(event))
  }

  selectedOptions() {
    return [...this.root.querySelectorAll('[data-option-position]')].map((group, index) => {
      const selected = group.querySelector('[data-option-value]:checked')
      const display = group.querySelector(`[data-option-label="${index + 1}"]`)
      if (display && selected) display.textContent = selected.value
      return selected?.value
    })
  }

  updateVariant() {
    const options = this.selectedOptions()
    const variant = this.variants.find(item => item.options.every((value, index) => value === options[index]))
    if (!variant) {
      this.button.disabled = true
      this.label.textContent = window.stratoStrings?.unavailable || 'Indisponible'
      return
    }
    this.variantInput.value = variant.id
    this.button.disabled = !variant.available
    this.label.textContent = variant.available ? (window.stratoStrings?.addToCart || 'Ajouter au panier') : (window.stratoStrings?.soldOut || 'Épuisé')
    if (this.price) this.price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(variant.price / 100)
    const url = new URL(window.location.href)
    url.searchParams.set('variant', variant.id)
    window.history.replaceState({}, '', url)
  }

  changeQuantity(delta) {
    const input = this.root.querySelector('input[name="quantity"]')
    if (!input) return
    input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + delta)
  }

  async addToCart(event) {
    event.preventDefault()
    if (!this.form || this.button.disabled) return
    this.button.setAttribute('aria-busy', 'true')
    this.error.hidden = true
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: new FormData(this.form)
      })
      if (!response.ok) throw new Error((await response.json()).description || 'Une erreur est survenue.')
      window.location.assign('/cart')
    } catch (error) {
      this.error.textContent = error.message
      this.error.hidden = false
      this.button.removeAttribute('aria-busy')
    }
  }
}

document.querySelectorAll('[data-product-root]').forEach(root => new StratoProduct(root))

document.querySelectorAll('.mobile-menu').forEach(menu => {
  menu.addEventListener('toggle', () => document.body.classList.toggle('menu-open', menu.open))
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => menu.removeAttribute('open')))
})

document.querySelectorAll('[data-sticky-add]').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelector('[data-add-to-cart]')?.click()
  })
})

document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
window.addEventListener('resize', () => document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`), { passive: true })
